import { Dispatch, FC, SetStateAction } from 'react';
// @ts-ignore
import { animated, config, Spring, Transition } from 'react-spring';
import styled from 'styled-components';
import { StyledSystemProps } from '../../../theme/StyledSystemProps';
import { theme } from '../../../theme';
import DeclarationAgreement from './DeclarationAgreement';

type ModalProps = StyledSystemProps & {
  onClose: () => null;
  open: boolean;
  openHandler: Dispatch<SetStateAction<boolean>>;
};

export const ModalWrap = styled(animated.div)`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: calc(100vw / var(--ib-ui-scale, 1));
  z-index: ${theme.zIndex[12]};
  height: calc(100vh / var(--ib-ui-scale, 1));
  display: flex;
  position: fixed;
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.3);
`;

const CustomModalInner = styled(animated.div)`
  width: 100%;
  height: 85%;
  position: absolute;
  bottom: 0;
  display: inline-block;
  max-width: 100%;
  border-radius: 5px;
  background-color: #f5f5f5;
  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);
`;

const DeclarationModal: FC<ModalProps> = ({ open, openHandler }) => (
  <Transition
    items={open}
    native={true}
    from={{
      opacity: 0,
      transform: 'translateY(40px)',
    }}
    enter={{
      opacity: 1,
      transform: 'translateY(0)',
    }}
    leave={{
      opacity: 0,
      transform: 'translateY(40px)',
      pointerEvents: 'none',
    }}
  >
    {(modalOpen: any) =>
      modalOpen &&
      ((props: any) => (
        <ModalWrap style={{ opacity: props.opacity }}>
          <Spring
            native={true as any}
            delay={500}
            config={config.default}
            from={{ opacity: 0, transform: 'translateX(-300px)' }}
            to={{ opacity: 1, transform: 'translateX(0)' }}
          >
            {(props: any) => (
              <CustomModalInner>
                <DeclarationAgreement openHandler={openHandler} />
              </CustomModalInner>
            )}
          </Spring>
        </ModalWrap>
      ))
    }
  </Transition>
);

export default DeclarationModal;
